
export const defaultHighlightedLinkButtonStyle = {
    color: "black",
    size: "md",
    bg: "pElementTransparent.850",
    borderRadius: "md",
    mr: "0",
    _hover: {
        textDecoration: "none",
        bg: "pElementTransparent.880",
    },
};

